<template>
  <v-container>
    <v-card class="my-5 elevation-0">
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn
          small
          class="mx-2"
          color="secondary"
          @click="downloadLink(document)"
        >
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>

        <v-btn
          :disabled="!$store.getters['Billing/invoiceMetadata']"
          class="mx-2"
          small
          color="success"
          @click="pay()"
        >
          Checkout
          <v-icon right> mdi-arrow-right </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-row>
        <v-col cols="8" offset="2" v-if="invoice">
          <v-card-text class="elevation-1 my-1">
            <pdf style="width: 100%" :src="invoice" />
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import FileMixin from "../../dashboard/mixin/FileMixin";
import pdf from "vue-pdf";

export default {
  name: "InvoiceComponent",
  components: { pdf },
  mixins: [FileMixin],

  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Billing/getInvoice", v.$route.params.code);
    });
  },

  computed: {
    invoice() {
      return this.$store.getters["Billing/invoice"];
    },
  },

  methods: {
    pay: function () {
      this.$billing.checkout({
        ...this.$store.getters["Billing/invoiceMetadata"],
      });
    },
  },
};
</script>

<style scoped></style>
